export default __webpack_public_path__ + "static/media/cleanproJGMBanner.0e09b76b.jpg";